import styled from 'styled-components';

/**
 * @deprecated use StyledElements. i.e. <Div /> or <H1 />
 */
var StyledContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledContainer",
  componentId: "sc-1usw3um-0"
})(["&&{", ";}"], function (_ref) {
  var $css = _ref.$css;
  return $css && $css;
});
export default StyledContainer;